module.exports = __webpack_public_path__ + "img/ball_9.4a244a85.png";